import { LegendListProps } from './LegendList';
import { Theme, css } from '@emotion/react';

export const legendListContainer =
  (orientation: LegendListProps['orientation'], gap: number) =>
  ({ spacing }: Theme) => css`
    display: flex;
    flex-direction: ${orientation === 'horizontal' ? 'row' : 'column'};
    gap: ${spacing(gap)}px;
  `;

export const legendListItem = ({ spacing }: Theme) => css`
  display: flex;
  align-items: flex-start;
  gap: ${spacing(0.5)}px;
`;

export const legendListItemIcon = css`
  svg {
    display: block;
  }
`;

/**
 * These padding nudges help us center the medium icon with the definition text
 * while allowing text to wrap and maintain top alignment. Future adjustments to the
 * type ramp/icon sizes may remove the need for these styles.
 */
export const legendListDefinition = ({ breakpoints }: Theme) => css`
  padding-top: 3px;

  ${breakpoints.up('md')} {
    padding-top: 2px;
  }
`;
